import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/fontawesome/scss/fontawesome.scss";
import "./assets/fontawesome/scss/solid.scss";

createApp(App).use(store).use(router).mount('#app')
